// 签名实现统一放在 @/utils/sign（原三份重复实现已合并），这里仅做转发，保持既有引用不变
export { signature } from '@/utils/sign'
